import { defineStore } from "pinia";
import ChatApi from "@/api/chat.api.ts";

const messages = ref([]);
const isMessagesLoading = ref(false);
const isMessageSending = ref(false);

const useAssessmentChatStore = defineStore('assessmentChat', () => {
    async function getMessages(planUuid: string, taskUuid: string, sessionUuid: string) {
        if(!planUuid || !taskUuid || !sessionUuid) {
            return;
        }

        isMessagesLoading.value = true;
        return await ChatApi.getMessages(planUuid, taskUuid, sessionUuid)
            .then(({data}) => {
                messages.value = data.data.reverse();
            })
            .finally(() => {
                isMessagesLoading.value = false;
            })
    }

    async function sendMessage(planUuid: string, taskUuid: string, sessionUuid: string, message: any) {
        return await ChatApi.sendMessage(
            planUuid,
            taskUuid,
            sessionUuid,
            message
        ).then((message) => {
            let existedMessage = messages.value.find(( m => m.uuid === message.uuid ));

            if(existedMessage) {
                existedMessage.value = message.value;
                existedMessage.files = message.files;
            } else {
                messages.value.push(message);
            }
            return Promise.resolve(message);
        }).finally(() => {
            isMessageSending.value = false;
        })
    }

    function clearState() {
        messages.value = [];
        isMessagesLoading.value = false;
    }

    return {
        messages,
        isMessagesLoading,
        getMessages,
        clearState,
        sendMessage,
        isMessageSending
    }
});

export default useAssessmentChatStore;